import React, { useEffect, useState } from 'react';

import { Container } from './styles';

import { Input, Autocomplete } from '~/components/Form';
import { get, isEmpty, isUndefined } from 'lodash';

import { toast } from 'react-toastify';

import {
  t,
  FormatarCodigoLiberacao,
  trocarCaracteresRetornaSomenteNumero,
  validarCPF,
} from '~/helpers';

import api from '~/services/api';


const InserirLibRemota = React.memo(props => {
  const { initials } = props;
  const [loading, setLoading] = useState(false);

  const [isLoading, setIsLoading] = useState(false);


  const [liberacaoRemota, setLiberacaoRemota] = React.useState({});

  const [valuePostoConfig, setValuePostoConfig] = React.useState({});
  const [valueBicoConfig, setValueBicoConfig] = React.useState({});

  const [valuePosto, setValuePosto] = React.useState(0);
  const [inputValuePosto, setInputValuePosto] = React.useState('');
  const [valueBico, setValueBico] = React.useState(0);
  const [inputValueBico, setInputValueBico] = React.useState('');

  const [valueCondCpf, setValueCondCpf] = React.useState('');
  const [
    valueVeicPlacaApresentacao,
    setValueVeicPlacaApresentacao,
  ] = React.useState('');
  const [valuekmLiberacao, setValuekmLiberacao] = React.useState('');


  const [infoOrgao, setInfoOrgao] = React.useState('');
  const [infoUnidade, setInfoUnidade] = React.useState('');
  const [infoMarcaModelo, setInfoMarcaModelo] = React.useState('');
  const [infoStatus, setInfoStatus] = React.useState('');
  const [infoAnoFabricacao, setInfoAnoFabricacao] = React.useState('');
  const [infoKmReferencia, setInfoKmReferencia] = React.useState('');
  const [infoBaseConsulta, setInfoBaseConsulta] = React.useState('');
  const [infoVeiculoInstalado, setInfoVeiculoInstalado] = React.useState('');

  //Limpa tela toda
  function handleLimpaTela() {
    props.reference.current.setFieldValue('cond_cpf', '');
    //reference.current.setFieldValue('cond_cpf', '');
    setValueCondCpf('');
    props.reference.current.setFieldValue('veic_placa_apresentacao', '');
    //reference.current.setFieldValue('veic_placa_apresentacao', '');
    setValueVeicPlacaApresentacao('');
    setValuekmLiberacao('');
    setInfoOrgao('');
    setInfoUnidade('');
    setInfoMarcaModelo('');
    setInfoStatus('');
    setInfoAnoFabricacao('');
    setInfoKmReferencia('');
    setInfoBaseConsulta('');
    setInfoVeiculoInstalado('');
    setLiberacaoRemota('');
  }

  function limpaInfo() {
    setInfoOrgao('');
    setInfoUnidade('');
    setInfoMarcaModelo('');
    setInfoStatus('');
    setInfoAnoFabricacao('');
    setInfoKmReferencia('');
    setInfoVeiculoInstalado('');
  }


  //********************************** */
  //Verificar modo de consulta pelo posto.
  useEffect(() => {
    let mounted = true;
    if (mounted) {
      const poco_codigo = get(valuePostoConfig, 'poco_codigo', '');

      if (String(poco_codigo) !== '') {
        const cosi_consul_libera_abast_siad = get(
          valuePostoConfig,
          'cosi_consul_libera_abast_siad',
          ''
        );
        const poco_interface_siad = get(
          valuePostoConfig,
          'poco_interface_siad',
          ''
        );
        if (
          Number(cosi_consul_libera_abast_siad) === 1 &&
          String(poco_interface_siad) === 'S'
        ) {
          setInfoBaseConsulta('SIAD');
        } else {
          setInfoBaseConsulta('SGTA');
        }
      } else {
        handleLimpaTela();
      }
    }
    return function cleanup() {
      mounted = false;
    };
  }, [valuePostoConfig]);


  //********************************** */
  //Verificar bico rotinas
  useEffect(() => {
    let mounted = true;
    if (mounted) {
      limpaInfo();
      //reference.current.setFieldValue('cond_cpf', '');
      props.reference.current.setFieldValue('cond_cpf', '');
      setValueCondCpf('');
      //reference.current.setFieldValue('veic_placa_apresentacao', '');
      props.reference.current.setFieldValue('veic_placa_apresentacao', '');
      setValueVeicPlacaApresentacao('');
    }
    return function cleanup() {
      mounted = false;
    };
  }, [valueBicoConfig]);

  //********************************** */
  //Verificar condutor rotinas
  useEffect(() => {
    let mounted = true;
    if (mounted) {
      const cpf = trocarCaracteresRetornaSomenteNumero(valueCondCpf, '');
      if (cpf.length >= 11) {

        if (String(infoBaseConsulta) === 'SIAD') {

          const idTerminal = get(valueBicoConfig, 'term_identificacao', '');
          if (String(idTerminal) !== '') {
            async function getData() {
              try {
                setIsLoading(true);
                const response = await api.get(
                  `/tcoudtmgconsultacondutorsiad/${idTerminal}/${cpf}`
                );
                setIsLoading(false);
                const statusRetorno = get(response, 'data.retorno', '');
                if (String(statusRetorno) === '') {
                  toast.error('Não foi possível fazer a consulta!');
                  return;
                }
                if (response && !isEmpty(response.data)) {
                  if (String(response.data.retorno) !== 'OK') {
                    props.reference.current.setFieldValue('cond_cpf', '');
                    //reference.current.setFieldValue('cond_cpf', '');
                    setValueCondCpf('');
                    toast.error(response.data.msgErro);
                    return;
                  }
                } else {
                  props.reference.current.setFieldValue('cond_cpf', '');
                  //reference.current.setFieldValue('cond_cpf', '');
                  setValueCondCpf('');
                }
              } catch (err) {

                setValueCondCpf('');

                props.reference.current && props.reference.current.setFieldValue('cond_cpf', '');
                //reference.current.setFieldValue('cond_cpf', '');
                setIsLoading(false);

                if (isUndefined(err.message)) {
                  toast.error(` ${err} `);
                } else {
                  const message = err.message;
                  if (message.includes("Cannot destructure property 'data' of 'error.response' as it is undefined.")) {
                    toast.error(`Falha na consulta do condutor! O tempo limite esgotou antes da conclusão da operação ou o servidor não está respondendo! (tcoudtmgconsultacondutorsiad)`);
                  } else {
                    toast.error(` ${err} `);
                  }
                }

              }
            }
            getData();
          }

        }

      }
    }
    return function cleanup() {
      mounted = false;
    };
  }, [valueCondCpf]);


  async function pequisaPlaca() {
    const placa = valueVeicPlacaApresentacao;
    if (placa.length >= 7) {
      const idTerminal = get(valueBicoConfig, 'term_identificacao', '');
      if (String(idTerminal) !== '') {
        try {
          setIsLoading(true);
          const response = await api.get(`/veiculo/${placa}`);
          setIsLoading(false);
          const statusRetorno = get(response, 'data', '');
          if (String(statusRetorno) === '') {
            limpaInfo();
            toast.error('Não foi possível fazer a consulta!');
            return;
          }
          if (response && !isEmpty(response.data)) {
            setInfoOrgao(
              `${response.data.orga_codigo} - ${response.data.orga_nome}`
            );
            setInfoUnidade(
              `${response.data.unid_codigo} - ${response.data.unid_nome}`
            );
            setInfoMarcaModelo(response.data.vemm_nome);
            setInfoStatus(response.data.veic_status);
            setInfoAnoFabricacao(response.data.veic_ano_fabricacao);
            setInfoKmReferencia(response.data.veic_totalizador_referencia);
            const veic_tag1 = get(response, 'data.veic_tag1', '');
            const veic_tag2 = get(response, 'data.veic_tag2', '');
            const veic_idxbee = get(response, 'data.veic_idxbee', '');
            if (
              veic_tag1.length > 1 ||
              veic_tag2.length > 1 ||
              veic_idxbee.length > 1
            ) {
              setInfoVeiculoInstalado('Sim');
            } else {
              setInfoVeiculoInstalado('Não');
            }
          } else {
            //reference.current.setFieldValue('veic_placa_apresentacao', '');
            props.reference.current.setFieldValue('veic_placa_apresentacao', '');
            setValueVeicPlacaApresentacao('');
            limpaInfo();
          }
        } catch (err) {

          limpaInfo();
          //reference.current.setFieldValue('veic_placa_apresentacao', '');
          props.reference.current.setFieldValue('veic_placa_apresentacao', '');
          setValueVeicPlacaApresentacao('');
          setIsLoading(false);

          if (isUndefined(err.message)) {
            const msgErro = 'Não encontrou placa no SGTA!';
            toast.error(`${msgErro}`);
          } else {

            const message = err.message;

            if (message.includes("Cannot destructure property 'data' of 'error.response' as it is undefined.")) {
              toast.error(`Falha na consulta da placa no SGTA! O tempo limite esgotou antes da conclusão da operação ou o servidor não está respondendo! (tcoudtmgconsultacondutorsiad)`);
            } else {
              const msgErro = 'Não encontrou registro no SGTA!!';
              toast.error(`${msgErro}`);
            }
          }
        }
      }
    }
  }

  //********************************** */
  //Verificar placa rotinas
  useEffect(() => {
    let mounted = true;
    if (mounted) {
      const placa = valueVeicPlacaApresentacao;
      if (placa.length >= 7) {
        if (String(infoBaseConsulta) === 'SIAD') {
          const idTerminal = get(valueBicoConfig, 'term_identificacao', '');
          if (String(idTerminal) !== '') {
            async function getData() {
              try {
                await setIsLoading(true);
                const response = await api.get(
                  `/tcoudtmgconsultaveiculosiadrest/${idTerminal}/${placa}`
                );
                await setIsLoading(false);
                const statusRetorno = get(response, 'data.retorno', '');
                if (String(statusRetorno) === '') {
                  limpaInfo();
                  toast.error('Não foi possível fazer a consulta!');
                  return;
                }
                if (response && !isEmpty(response.data)) {
                  if (String(response.data.retorno) !== 'OK') {
                    limpaInfo();
                    setValueVeicPlacaApresentacao('');
                    props.reference.current.setFieldValue('veic_placa_apresentacao', '');
                    //reference.current.setFieldValue('veic_placa_apresentacao',  '' );
                    toast.error(response.data.msgErro);
                    return;
                  } else {
                    pequisaPlaca();
                  }
                } else {
                  limpaInfo();
                  setValueVeicPlacaApresentacao('');
                  //reference.current.setFieldValue('veic_placa_apresentacao','');
                  props.reference.current.setFieldValue('veic_placa_apresentacao', '');
                }
              } catch (err) {
                limpaInfo();
                setValueVeicPlacaApresentacao('');
                //reference.current.setFieldValue('veic_placa_apresentacao', '');
                props.reference.current.setFieldValue('veic_placa_apresentacao', '');
                setIsLoading(false);

                //toast.error(` ${err} `);

                if (isUndefined(err.message)) {
                  toast.error(` ${err} `);
                } else {
                  const message = err.message;
                  if (message.includes("Cannot destructure property 'data' of 'error.response' as it is undefined.")) {
                    toast.error(`Falha na consulta do veículo! O tempo limite esgotou antes da conclusão da operação ou o servidor não está respondendo! (tcoudtmgconsultaveiculosiadrest)`);
                  } else {
                    toast.error(` ${err} `);
                  }
                }

              }

            }



            setIsLoading(true);
            getData();
          }
        } else {
          pequisaPlaca();
        }
      }
      else {
        limpaInfo();
      }

    }
    return function cleanup() {
      mounted = false;
    };
  }, [valueVeicPlacaApresentacao]);


  return (

    <Container>

      Inserir Liberação

      <>
        <Autocomplete
          name="poco_codigo"
          label="poco_desc_abrev"
          title="Posto"
          id="poco_codigo"
          url="postoscofing"
          unique="poco_codigo"
          disabled={String(liberacaoRemota.retorno) === 'OK'}
          value={valuePosto}
          inputValue={inputValuePosto}
          onChange={(event, newValue) => {
            setValuePosto(newValue);
          }}
          onInputChange={(event, newInputValuePosto) => {
            setInputValuePosto(newInputValuePosto);
          }}
          defaultValue=""
          hiddens={[{ name: 'poco_desc_abrev' }]}
          getValue={(value) => {
            setValueBico(0);
            setInputValueBico('');
            if (value.poco_codigo !== null) {
              setValuePostoConfig(value);
              setValuePosto(value.poco_codigo);
            } else {
              setValuePostoConfig({});
              setValuePosto(0);
            }
          }}
        />

        <Autocomplete
          name="bico_numero"
          label="bico_descricao"
          title="Bico"
          id="bico_numero"
          url="bicos"
          unique="bico_numero"
          disabled={String(liberacaoRemota.retorno) === 'OK'}
          value={valueBico}
          inputValue={inputValueBico}
          onChange={(event, newValue) => {
            setValueBico(newValue);
          }}
          onInputChange={(event, newInputValueBico) => {
            setInputValueBico(newInputValueBico);
          }}
          defaultValue=""
          hiddens={[{ name: 'bico_descricao' }, { name: 'term_identificacao' }]}
          getValue={(value) => {
            if (value.bico_numero !== null) {
              setValueBicoConfig(value);
              setValueBico(value.bico_numero);
            } else {
              setValueBicoConfig({});
              setValueBico(0);
            }
          }}
          params={{
            wherefield: 'poco_codigo',
            valuewherefield: valuePosto,
            typewherefield: 'EQUALS',
          }}
        />

        <Input
          name="cond_cpf"
          label="Condutor"
          disabled={String(liberacaoRemota.retorno) === 'OK'}
          value={valueCondCpf}
          getValue={(value) => {
            setValueCondCpf(value);
          }}
        />

        <Input
          name="veic_placa_apresentacao"
          label="Placa"
          disabled={String(liberacaoRemota.retorno) === 'OK'}
          value={valueVeicPlacaApresentacao}
          getValue={(value) => {
            setIsLoading(true);
            setValueVeicPlacaApresentacao(value);
          }}
        />

        <div className="Container__liberacao_cabecalho">
          <Input
            name="orgao_dec"
            label="órgão"
            value={infoOrgao}
            disabled
          />

          <Input
            name="unidade_dec"
            label="Unidade"
            value={infoUnidade}
            disabled
          />

          <Input
            name="marcamodelo_dec"
            label="Marca/Modelo"
            value={infoMarcaModelo}
            disabled
          />

          <Input
            name="status_dec"
            label="Status"
            value={infoStatus}
            disabled
          />

          <Input
            name="ano_fabricacao_dec"
            label="Ano Fabricação"
            value={infoAnoFabricacao}
            disabled
          />

          <Input
            name="km_referencia_dec"
            label="Km Referência"
            value={infoKmReferencia}
            disabled
          />

          <Input
            name="base_consulta_dec"
            label="Base de Consulta"
            value={infoBaseConsulta}
            disabled
          />

          <Input
            name="veiculo_instalado_dec"
            label="Veículo instalado"
            value={infoVeiculoInstalado}
            disabled
          />
        </div>

        <Input
          name="km_liberacao"
          label="KM"
          type="number"
          //disabled={String(liberacaoRemota.retorno) === 'OK'}
          value={valuekmLiberacao}
          getValue={(value) => {
            setValuekmLiberacao(value);
          }}
        />

      </>


    </Container>
  );
}
);

export default InserirLibRemota;